import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'filter-button',
    templateUrl: './filter-button.component.html',
    styleUrls: ['./filter-button.component.css'],
    standalone: false
})
export class FilterButtonComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
